// import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { PershingError } from '@pershing/pershing-core';
import { Email } from '../models/e-mail.model';
import { Emailresponse } from '../models/emailresponse.model';
import { MOCK_EMAIL_RESPONSE } from './mock-email-response';

// let headers = new HttpHeaders({
//     'Content-Type':  'application/json'
// });

@Injectable()
export class MockEmailsService {
    emailresponse$: Observable<Emailresponse>;
    error$: Observable<PershingError>;
    private _emailsResponse: BehaviorSubject<Emailresponse>;
    private _error: BehaviorSubject<PershingError>;
    private dataStore: {
        emailsResponse: Emailresponse;
    };
    constructor() {
        this._error = new BehaviorSubject<PershingError>(null);
        this.error$ = this._error.asObservable();
        this._emailsResponse = <BehaviorSubject<Emailresponse>>new BehaviorSubject(null);
        this.emailresponse$ = this._emailsResponse.asObservable();
        this.dataStore = { emailsResponse: null };
    }
    getUserEmails(): Email[] {
        return MOCK_EMAIL_RESPONSE.response;
    }
    retrieveEmails(): void {
        let data = MOCK_EMAIL_RESPONSE;
        let emailsResponse: Emailresponse = new Emailresponse();
        emailsResponse.emails = data.response;
        this.dataStore.emailsResponse = emailsResponse;
        this._emailsResponse.next(Object.assign({}, this.dataStore).emailsResponse);
    }
}
